<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12>
        <v-parallax
          dark
          :src="require('@/assets/main.jpg')"
          :height="windowSize.y"
        >
          <v-layout align-center justify-center row fill-height>
            <v-responsive class="pa-5">
              <v-flex xs12 class="text-xs-center">
                <img
                  class="pa-2"
                  src="@/assets/duris.png"
                  style="opacity: 0.9"
                />
              </v-flex>
            </v-responsive>
          </v-layout>
        </v-parallax>
      </v-flex>
      <v-divider class="my-3"></v-divider>
    </v-layout>

    <v-layout row>
      <v-flex xs12>
        <v-container grid-list-xl>
          <h3 class="display-1 text-xs-center py-5">Novinky</h3>
          <v-layout row wrap align-center justify-center fill-height>
            <v-flex xs12 sm6 md6 lg6 xl4 v-for="n in main" :key="n.id">
              <v-hover v-if="n.action">
                <v-card
                  :to="n.action"
                  :style="{ cursor: 'pointer', height: '100%' }"
                  slot-scope="{ hover }"
                  :class="
                    `transparent elevation-${
                      hover ? 12 : 0
                    } pa-4 text-xs-center`
                  "
                  min-height="330px"
                >
                  <v-card-text class="text-xs-center">
                    <v-icon x-large class="primary--text">{{ n.icon }}</v-icon>
                  </v-card-text>
                  <v-card-title primary-title class="layout justify-center">
                    <div class="headline text-xs-center">
                      {{ n.title }}
                      <v-icon v-if="n.titleIcon" color="info">{{
                        n.titleIcon
                      }}</v-icon>
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <div v-html="n.desc"></div>
                  </v-card-text>
                </v-card>
              </v-hover>
              <v-hover v-else>
                <v-card
                  @click="openNewTab(n.link)"
                  :style="{ cursor: 'pointer', height: '100%' }"
                  slot-scope="{ hover }"
                  :class="
                    `transparent elevation-${
                      hover ? 12 : 0
                    } pa-4 text-xs-center`
                  "
                  min-height="330px"
                >
                  <v-card-text class="text-xs-center">
                    <v-icon x-large class="primary--text">{{ n.icon }}</v-icon>
                  </v-card-text>
                  <v-card-title primary-title class="layout justify-center">
                    <div class="headline text-xs-center">
                      {{ n.title }}
                      <v-icon v-if="n.titleIcon" color="info">{{
                        n.titleIcon
                      }}</v-icon>
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <div v-html="n.desc"></div>
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <!-- <v-layout row wrap align-center justify-center fill-height class="pt-5">
      <v-flex xs12 sm8>
        <v-card class="elevation-0 transparent text-xs-center">
          <v-card-title primary-title class="layout justify-center">
            <div>
              <h3 class="display-1 text-xs-center pb-5">Služby</h3>
            </div>
          </v-card-title>

          <v-card-text>
            <v-timeline clipped>
              <v-timeline-item v-for="(item, i) in years" :key="i" color="white" fill-dot small>
                <template v-slot:opposite>
                  <span :class="`headline primary--text`" v-text="item.title"></span>
                </template>
                <template v-slot:icon>
                  <v-icon color="secondary" large>info</v-icon>
                </template>
                <div class="py-3">
                  <div>{{item.text}}</div>
                </div>
              </v-timeline-item>
            </v-timeline>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>-->
  </div>
</template>

<script>
export default {
  name: "Home",
  components: {},
  data() {
    return {
      main: [
        {
          title: "Nárezové plány",
          titleIcon: "",
          icon: "view_quilt",
          desc:
            "Nový modul nárezové plány. V sekcii rezanie materiálu si môžete vytvoriť objednávku na pravouhlé rezanie a olepovanie veľkoplošných materiálov. Okamžite budete vedieť koľko zaplatíte. Súčasťou je vizualizácia nárezových plánov.",
          action: "cutting",
        },
        {
          title: "Článok v časopise daibau.sk",
          titleIcon: "",
          icon: "assignment",
          desc:
            "Pre nábytok na mieru sa jednotlivci zvyčajne rozhodnú v špeciálnych prípadoch, keď je to jediná možnosť, ako si zariadiť svoj príbytok. Dôvod zvyčajne spočíva v neobvyklých rozmeroch konkrétneho priestoru, do ktorého sa nezmestí štandardný, typový alebo továrensky vyrobený nábytok.",
          link: "https://www.daibau.sk/clanok/435/nabytok_na_mieru",
        },
        // {
        //   title: "Poradenstvo",
        //   icon: "info",
        //   desc: "Radi Vám poradíme s výberom farieb, materiálov a designom."
        // },
        // {
        //   title: "Návrh",
        //   icon: "desktop_mac",
        //   desc:
        //     "Podľa Vašich požiadaviek a zamerania pomocou grafickej vizualizácie ukážeme nábytok na mieru pre lepšiu predstavu ešte pred začiatkom výroby."
        // },
        // {
        //   title: "Výroba",
        //   icon: "settings",
        //   desc: "Nábytok na mieru vyrobíme podľa požiadaviek."
        // },
        // {
        //   title: "Doprava",
        //   icon: "local_shipping",
        //   desc:
        //     "Podľa priania zabezpečíme montáž nábytku, resp. dopravu na Vami určené miesto."
        // },
        // {
        //   title: "Montáž",
        //   icon: "build",
        //   desc: "dasj djsaiod jasiodjaiosdjd ijdo"
        // },
        // {
        //   title: "Frézovanie materiálov",
        //   icon: "category",
        //   desc:
        //     "Frézovanie je určené predovšetkým na opracovanie rovinných plôch a tiež na obrábanie tvarových plôch. Hlavný rezný pohyb vykonáva nástroj – fréza, a obrobok vykonáva pohyb do rezu. Pri frézovaní sa prierez triesky mení v dôsledku cykloidnej trajektórie rezného pohybu nástroja"
        // }
      ],
      years: [
        {
          color: "cyan",
          title: "Poradenstvo",
          text: "Radi Vám poradíme s výberom farieb, materiálov a designom.",
        },
        {
          color: "green",
          title: "Návrh",
          text:
            "Podľa Vašich požiadaviek a zamerania pomocou grafickej vizualizácie ukážeme nábytok na mieru pre lepšiu predstavu ešte pred začiatkom výroby.",
        },
        {
          color: "pink",
          title: "Výroba",
          text: "Nábytok na mieru vyrobíme podľa požiadaviek.",
        },
        {
          color: "orange",
          title: "Doprava",
          text: "dasj djsaiod jasiodjaiosdjd ijdo",
        },
        {
          color: "amber",
          title: "Montáž",
          text:
            "Podľa priania zabezpečíme montáž nábytku, resp. dopravu na Vami určené miesto.",
        },
      ],
      windowSize: {},
    };
  },
  mounted() {
    this.onResize();
  },
  methods: {
    onResize() {
      this.windowSize = {
        x: window.innerWidth,
        y: window.innerHeight - 48,
      };
    },
    openNewTab(link) {
      window.open(link, "_blank");
    },
  },
};
</script>

<style></style>
